// @ts-nocheck
// Modal generico de denuncia UGC (Apple Guideline 1.2). Usado tanto pra
// clube quanto pra post/citacao — recebe `kind` + `id` + funcao submit.
import React, { useEffect, useState } from 'react';
import { Icon } from './icons';
import { Sheet } from './common';

interface Props {
  open: boolean;
  onClose: () => void;
  targetLabel: string; // ex: "Clube: Manhãs com Bonhoeffer" ou "Citação"
  onSubmit: (reason: string) => Promise<void>;
}

const REASONS = [
  'Spam ou divulgação não autorizada',
  'Linguagem abusiva ou ofensiva',
  'Conteúdo ilegal',
  'Assédio ou bullying',
  'Conteúdo sexual',
  'Discurso de ódio',
  'Outro',
];

export const ReportSheet: React.FC<Props> = ({ open, onClose, targetLabel, onSubmit }) => {
  const [selectedReason, setSelectedReason] = useState<string>('');
  const [detail, setDetail] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!open) {
      setSelectedReason(''); setDetail(''); setError(null); setSaving(false); setSuccess(false);
    }
  }, [open]);

  const submit = async () => {
    if (saving) return;
    if (!selectedReason) { setError('Selecione um motivo.'); return; }
    const fullReason = detail.trim()
      ? `${selectedReason} — ${detail.trim()}`
      : selectedReason;
    if (fullReason.length < 5) { setError('Descreva o motivo.'); return; }
    setSaving(true); setError(null);
    try {
      await onSubmit(fullReason);
      setSuccess(true);
      setTimeout(() => onClose(), 1500);
    } catch (e: any) {
      setError(e?.message || 'Erro ao enviar denúncia');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Sheet open={open} onClose={() => !saving && onClose()}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div>
          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ember)' }}>Denúncia</div>
          <div className="serif" style={{ fontSize: 24, lineHeight: 1.1 }}>Denunciar conteúdo</div>
        </div>
        <button onClick={() => !saving && onClose()} style={{
          width: 32, height: 32, borderRadius: '50%',
          background: 'var(--paper-2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}><Icon name="close" size={16}/></button>
      </div>

      {success ? (
        <div style={{
          padding: '32px 16px', textAlign: 'center',
          borderRadius: 16, background: 'rgba(94,113,86,0.12)', border: '1px solid rgba(94,113,86,0.28)',
          marginTop: 12,
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            background: 'var(--sage)', color: 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px',
          }}>
            <Icon name="check" size={22} color="white" stroke={2.6}/>
          </div>
          <div className="serif" style={{ fontSize: 20, lineHeight: 1.2 }}>Denúncia enviada</div>
          <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 6, lineHeight: 1.5 }}>
            Vamos revisar em até 24h. Se confirmado, o conteúdo é removido e o autor pode ser banido.
          </div>
        </div>
      ) : (
        <>
          <div style={{
            padding: '10px 14px', borderRadius: 12,
            background: 'var(--paper-2)', border: '1px solid var(--line)',
            fontSize: 12.5, color: 'var(--ink-3)', lineHeight: 1.45,
            marginTop: 4,
          }}>
            Denunciando: <strong style={{ color: 'var(--ink-2)' }}>{targetLabel}</strong>
          </div>

          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-3)', marginTop: 16, marginBottom: 8 }}>
            Motivo
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {REASONS.map(r => (
              <button key={r} onClick={() => setSelectedReason(r)} style={{
                padding: '12px 14px', borderRadius: 12,
                background: selectedReason === r ? 'var(--ember-soft)' : 'var(--paper-2)',
                border: '1px solid ' + (selectedReason === r ? 'var(--ember)' : 'var(--line)'),
                color: selectedReason === r ? 'var(--ember)' : 'var(--ink)',
                fontSize: 14, textAlign: 'left',
                fontWeight: selectedReason === r ? 600 : 400,
              }}>
                {r}
              </button>
            ))}
          </div>

          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-3)', marginTop: 16, marginBottom: 6 }}>
            Detalhes (opcional)
          </div>
          <textarea
            value={detail}
            onChange={e => setDetail(e.target.value)}
            placeholder="Conte mais sobre o que aconteceu"
            maxLength={1500}
            rows={4}
            style={{
              width: '100%', padding: '12px 14px', borderRadius: 12,
              border: '1px solid var(--line)',
              background: 'var(--paper-2)',
              fontSize: 14, fontFamily: 'inherit', color: 'var(--ink)',
              outline: 'none', boxSizing: 'border-box',
              resize: 'vertical', minHeight: 80,
            }}
          />

          {error && (
            <div style={{
              marginTop: 12, padding: '10px 14px', borderRadius: 12,
              background: 'rgba(199,83,26,0.10)', border: '1px solid rgba(199,83,26,0.22)',
              color: 'var(--ember)', fontSize: 13,
            }}>
              {error}
            </div>
          )}

          <button onClick={submit} disabled={saving} style={{
            width: '100%', marginTop: 16,
            background: saving ? 'var(--paper-3)' : 'var(--ember)',
            color: saving ? 'var(--ink-4)' : 'var(--paper)',
            padding: '15px', borderRadius: 14, fontSize: 14.5, fontWeight: 500,
            border: 'none',
          }}>
            {saving ? 'Enviando...' : 'Enviar denúncia'}
          </button>

          <div className="mono" style={{
            marginTop: 12, fontSize: 9.5, letterSpacing: '0.10em',
            color: 'var(--ink-4)', textAlign: 'center', lineHeight: 1.5,
          }}>
            Respondemos em até 24h. Conteúdo abusivo é removido e o autor banido.
          </div>
        </>
      )}
    </Sheet>
  );
};

// ─────────────────────────────────────────────────────────────────────
// Hook util pra detectar long-press num elemento (mobile-friendly).
// Tap normal = nao dispara. Press >= 500ms = dispara.
// Returns: { onPointerDown, onPointerUp, onPointerCancel, onPointerMove }
// ─────────────────────────────────────────────────────────────────────
export function useLongPress(onLongPress: () => void, delay = 500) {
  const ref = React.useRef<{ timer: any; fired: boolean; startX: number; startY: number }>({ timer: null, fired: false, startX: 0, startY: 0 });

  const clear = () => {
    if (ref.current.timer) { clearTimeout(ref.current.timer); ref.current.timer = null; }
  };

  return {
    onPointerDown: (e: React.PointerEvent) => {
      ref.current.fired = false;
      ref.current.startX = e.clientX; ref.current.startY = e.clientY;
      clear();
      ref.current.timer = setTimeout(() => {
        ref.current.fired = true;
        try { onLongPress(); } catch {}
      }, delay);
    },
    onPointerMove: (e: React.PointerEvent) => {
      const dx = e.clientX - ref.current.startX;
      const dy = e.clientY - ref.current.startY;
      if (dx * dx + dy * dy > 100) clear(); // moveu mais de ~10px, cancela
    },
    onPointerUp: () => { clear(); },
    onPointerCancel: () => { clear(); },
    onPointerLeave: () => { clear(); },
    didFire: () => ref.current.fired,
  };
}
